import { setErrorDialog, serverUrl, getheader } from "./CommonFunctions";

export function getExtAttrSettings() {
    return dispatch => {
        fetch(serverUrl + "api/SystemSetting/GetExtAttrSettings", {
            headers: {
                "Content-Type": "application/json",
                "Data-Type": "JSON"
            },
            method: "GET",
            cache: "force-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error") {
                    res = [];
                }
                return dispatch({
                    type: "GET_EXT_SETTINGS",
                    data: res
                })
            }).catch(e => {
                console.log("[GET_EXT_SETTINGS] ", e);
                return dispatch({
                    type: "GET_EXT_SETTINGS",
                    data: []
                })
            });
    }
}
export function getSystemSettings(data) {
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (token === null || sUrl === null) {
      return dispatch => {
        dispatch({
          type: "GET_SYSTEM_SETTINGS",
          data: []
        });
      }
    }
    return dispatch => {
        fetch(sUrl + "api/SystemSetting/GetSystemSettings", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error") {
                    res = [];
                }
                return dispatch({
                    type: "GET_SYSTEM_SETTINGS",
                    data: res
                });
            }).catch(e => {
                console.log("[GET_SYSTEM_SETTINGS] ", e);
                return dispatch({
                    type: "GET_SYSTEM_SETTINGS",
                    data: []
                })
            });
    }
}
export function getPrintTemplate(templateName) {
    return dispatch => {
        dispatch({
            type: "GET_PRINT_TEMPLATE",
            data: "PENDING"
        });
        fetch(serverUrl + "api/PrintTemplateAPI/GetTemplate?templateName=" + templateName, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Error" || res.Message) {
                    res = null;
                }
                dispatch({
                    type: "GET_PRINT_TEMPLATE",
                    data: res
                });                
            })
    }
} 
export function setPrintViewerPopStatus(status)
{
    return dispatch=>{
        dispatch({
            type:"PRINT_VIEW_POPSTATUS",
            data:status
        });
    }
}
export function checkSystemVersion()
{
    return dispatch =>{
        fetch(serverUrl + "api/SystemSetting/CheckSystemVersion",{
            method:"GET",
            headers:getheader(),
            cache:"default"
        }).then(res=>res.json()).then(res=> dispatch({type:"CHECK_VERSION",data:res}));
    }
}
export function getCustomerExtAttrSettings(){
    return dispatch =>{
        fetch(serverUrl +`api/SystemSetting/GetCustomerExtSettings`,{
            method:"GET",
            headers:getheader(),
            cache:"no-cache"
        } ).then(res=>res.json())
           .then(res=>{
            if(res.Message)
            {
                setErrorDialog(dispatch,res.Message, "تنظیمات مشتریان");
                return;
            }
            dispatch({
                type:"GET_CUSTOMER_EXT_SETTINGS",
                data:res
            })
           })
           .catch(e=> console.log("[GET_CUSTOMER_EXT_SETTINGS]",e));
    }
}